<template>
  <div
    class="font-degular mx-auto my-auto pb-32 px-4 sm:px-8 md:px-10 min-h-screen contain h-auto flex flex-col justify-center bg-transparent overflow-visible"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'SPage'
}
</script>
